<template>
  <section class="services-area ptb-70">
    <div class="container-fluid p-0">
      <h2>What is iRecharge Pay?</h2>
      <p
        style="margin-left: 7%; margin-right: 7%;"
      >IRecharge Pay is a multifunction omni-channel payment system which provides convenient and safe digital alternatives to tendering/receiving payments.</p>
      <p style="margin-left: 7%; margin-right: 7%;">
        Studies show access to finance is positively correlated with economic growth and employment. This service enables registered users to withdraw cash, store money, make payments and send money P-2-P using their mobile phones or at any iRecharge merchant location.
        It also provides an alternative payment/collection system for businesses
      </p>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
</style>